
import React,{useState , useEffect} from 'react';
import api , { fetchUserProfile } from "../../utilities/api";

import { 
    UpdatePasswordModal
 } from "../../components";


const AccountDetails = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form, setForm] = useState({
        first_name: '',
        last_name: '',
        email: '',
    });
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);


    useEffect(() => {
        const getProfileData = async () => {
            try {
                const { first_name, last_name, email } = await fetchUserProfile();
                setForm({ first_name, last_name, email });
            } catch (error) {
                console.error("Failed to load profile", error);
            } finally {
                setLoading(false);
            }
        };
        getProfileData();
    }, []);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setForm({ ...form, [id]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.post("/auth/profile", form);
            alert("Profile updated successfully!");
        } catch (error) {
            console.error("Update failed", error);
            alert("Something went wrong.");
        } finally {
            setSubmitting(false);
        }
    };

    const handleDelete = async () => {
        if (!window.confirm("Are you sure you want to delete your account? This cannot be undone.")) return;
        try {
            await api.delete("/auth/profile");
            document.cookie = "token=; Max-Age=0; path=/;";
            alert("Account deleted.");
            window.location.href = "/login";
        } catch (error) {
            console.error("Delete failed", error);
            alert("Unable to delete account.");
        }
    };
    return (
       
        <div>

            <div className="pt-8">
                <div className="flex items-center w-full pb-5">
                    <h2 className="text-base font-medium text-primary-0 font-redhat">Personal Information</h2>
                    <div className="relative flex-grow ml-4 border-b border-gray-100 top-2"></div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-9">

                    <div className="relative w-full">
                        <input type="text" id="first_name" value={form.first_name} readOnly
                            className="w-full p-3 text-gray-900 border border-gray-100 rounded-lg outline-none peer"
                            placeholder=" " />
                        <label htmlFor="first_name"
                            className="bg-gray-0 absolute left-4 -top-[10px] text-gray-700 text-sm leading-5.5 font-medium font-redhat transition-all peer-placeholder-shown:top-4"
                        >First Name</label>
                    </div>

                    <div className="relative w-full">
                        <input type="text" id="last_name" value={form.last_name} readOnly
                            className="w-full p-3 text-gray-900 border border-gray-100 rounded-lg outline-none peer"
                            placeholder=" " />
                        <label htmlFor="last_name"
                            className="bg-gray-0 absolute left-4 -top-[10px] text-gray-700 text-sm leading-5.5 font-medium font-redhat transition-all peer-placeholder-shown:top-4"
                        >Last Name</label>
                    </div>
                    <div className="sm:col-span-2 flex justify-end">
        <button
            onClick={handleSubmit}
            disabled={submitting}
            className={`px-6 py-2 text-white font-medium rounded-full transition-all duration-200
                ${submitting ? 'bg-gray-800 cursor-not-allowed text-gold-500' : 'bg-gray-300 hover:bg-gold-300 text-gold-50 '}`}
        >
            {submitting ? "Saving..." : "Save"}
        </button>
    </div>
                    <div className="relative w-full">
                        <input type="text" id="email-address" value={form.email} readOnly
                            className="w-full p-3 text-gray-900 border border-gray-100 rounded-lg outline-none peer"
                            placeholder=" " />
                        <label htmlFor="email-address"
                            className="bg-gray-0 absolute left-4 -top-[10px] text-gray-700 text-sm leading-5.5 font-medium font-redhat transition-all peer-placeholder-shown:top-4"
                        >Email Address</label>
                    </div>
                </div>
            </div>


            <div className="pt-8">
                <div className="flex items-center w-full pb-3">
                    <h2 className="text-base font-medium text-primary-0 font-redhat">Login & security</h2>
                    <div className="relative flex-grow ml-4 border-b border-gray-100 top-2"></div>
                </div>

                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-base text-gray-700 font-redhat">Password</p>
                        <p className="text-base text-gray-80 font-redhat">Last updated 10 months ago</p>
                    </div>
                    <div>
                        <button onClick={()=> setIsModalOpen(true)} className='text-sm font-medium leading-4 text-gold-300 font-redhat'>Update</button>
                         {/* Render modal only when isModalOpen is true */}
            {isModalOpen && <UpdatePasswordModal onClose={() => setIsModalOpen(false)} />}
                    </div>
                </div>
            </div>

            <div className="pt-8">
                <div className="flex items-center w-full pb-3">
                    <h2 className="text-base font-medium text-primary-0 font-redhat">Account</h2>
                    <div className="relative flex-grow ml-4 border-b border-gray-100 top-2"></div>
                </div>

                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-base text-gray-700 font-redhat">Delete your account</p>
                    </div>
                    <div>
                        <a href="#" onClick={(e) => {
                                e.preventDefault();
                                handleDelete();
                            }} className='text-sm font-medium leading-4 text-red-100 font-redhat'>Delete</a>
                    </div>
                </div>
            </div>

        </div>
               
    )
}

export default AccountDetails;